module.exports = __webpack_public_path__ + "static/img/about_icon.206748b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_icon.png
// module id = zJPQ
// module chunks = 1